export const hardwarecol = [
  {
    title: "Category",
    dataIndex: "Category",
    key: "Category",
  },
  {
    title: "Description",
    dataIndex: "Description",
    key: "Description",
  },
  {
    title: "Serial",
    dataIndex: "Serial",
    key: "Serial",
  },
  {
    title: "Date Loaned",
    dataIndex: "DateLoaned",
    key: "DateLoaned",
  },
  {
    title: "Date Returned",
    dataIndex: "DateReturned",
    key: "DateReturned",
  },
  {
    title: "Assets Cost",
    dataIndex: "AssetsCost",
    key: "AssetsCost",
  },
  {
    title: "Notes",
    dataIndex: "Notes",
    key: "Notes",
  },
];

export const softwarecol = [
  {
    title: "Category",
    dataIndex: "Category",
    key: "Category",
  },
  {
    title: "Description",
    dataIndex: "Description",
    key: "Description",
  },
  {
    title: "Provider",
    dataIndex: "Provider",
    key: "Provider",
  },
  {
    title: "License key",
    dataIndex: "Licensekey",
    key: "Licensekey",
  },
  {
    title: "Subscription Date",
    dataIndex: "SubscriptionDate",
    key: "SubscriptionDate",
  },
  {
    title: "Expiry Date",
    dataIndex: "ExpiryDate",
    key: "ExpiryDate",
  },
  {
    title: "Assets Cost",
    dataIndex: "AssetsCost",
    key: "AssetsCost",
  },
  {
    title: "Notes",
    dataIndex: "Notes",
    key: "Notes",
  },
];
